import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Params } from '@angular/router';
import { StreamService, TenantService } from '../services'
import { CategoryStreamsRequestModel } from '../model'
import { Subject, forkJoin, of } from "rxjs";
import { flatMap, takeUntil } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
    template: `
        <topic-summary-grid [topics]="topics" [emptyMessage]="emptyMessage"></topic-summary-grid>
    `})
export class BrowseCategoryPaneComponent implements OnInit, OnDestroy {
    topics: any;
    cleanupTime = new Subject<void>();
    isNew: boolean;

    constructor(private route: ActivatedRoute, private streamService: StreamService, private tenantService: TenantService){
    }
    ngOnInit(): void {    
        this.route.data.pipe(takeUntil(this.cleanupTime)).subscribe((data: Data) => {
            this.isNew = data.isNew;
        });

        this.route.params.pipe(
            flatMap((params: Params) => forkJoin([of(params), this.tenantService.getUnauthTenantInfo()])),
            flatMap(([params, tenant]) => tenant.settings.hideCategories === 'true' ? this.getTenantStreams() : this.getCategoryStreams(params.categoryId)),
            takeUntil(this.cleanupTime)
        ).subscribe(topics => this.topics = topics.content.filter(stream => stream.published))
    }

    getTenantStreams = () => {
        const params: { page: number, rows: number, includeCatalogs: boolean, published: boolean, createdAfterDateTime?: string } = { 
            page: 0, 
            rows: 500, 
            includeCatalogs: false, 
            published: true
        };
        if (this.isNew) {
            params.createdAfterDateTime = moment().subtract(30, 'days').toISOString();
        }
        return this.streamService.getTenantStreams(params); 
    }

    getCategoryStreams(categoryId) {
        const request = this.isNew ? 
            new CategoryStreamsRequestModel(categoryId, true, true, 0, 500, moment().subtract(30, 'days').toISOString()) : 
            new CategoryStreamsRequestModel(categoryId, true, true, 0, 500);
        return this.streamService.getCategoryStreams(request);
    }

    get emptyMessage(): string {
        return this.isNew ? 
            'No new topics have been added in the last 30 days.' : 
            'This category doesn\'t have any topics yet.';
    }

    ngOnDestroy() {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    };
}
